/*********************** Custom JS for Boost AI Search & Discovery  ************************/
function _isMobileDevice() {
 return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

function _isCollectionPage() {
 return window.location.pathname.includes('/collections');
};

const selectors = {
  productImage: '.boost-sd__product-image',
}

function formRequest(value) {
    return new Promise((resolve, reject) => {
        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open("GET", Shopify.routes.root + 'products/' + value + '?view=boost-pfs-integration');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => resolve(xhr.responseText);
        xhr.onerror = () => reject(xhr.statusText);
        xhr.send();
    });
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductItem', {
            name: 'ProductList - call get Products Data',
            apply() {
                return {
                    async afterRender(element) {
                        let productHandle = '';
                        if (element.getParams().props && element.getParams().props.product) {
                            productHandle = element.getParams().props.product.handle;
                        }

                        let requestReg = formRequest(productHandle);
                        requestReg.then((res_success) => {
                            let res = JSON.parse(res_success);
                            let productItem = document.querySelector(`.boost-sd__product-item[data-product-id="` + res.id + `"] `);
                            let quickViewModal = document.querySelector(`.boost-sd__quick-view[product-id="` + res.id + `"] `);
                            // productItem.querySelector('.boost-sd__product-link').removeAttribute('href');
                            if( _isMobileDevice() && _isCollectionPage()) {
                              productItem.querySelector('.boost-sd__product-image').innerHTML = res.product_image;
                            }
                            // productItem.querySelector('.boost-sd__product-image').innerHTML = res.product_image;
                            productItem.querySelector('.boost-sd__product-image-column--in-top').innerHTML = res.label;
                            quickViewModal.querySelector('.boost-sd__product-image-column--in-top').innerHTML = res.label;
                            // productItem.querySelector('.boost-sd__product-image-column--in-bottom').innerHTML = res.quickBuy;
                            
                          
                        }).catch((res_error) => {
                            // console.log(res_error)
                        });
                    },
                };
            },
        });
    }
]);






/* images sliders */

function buildProductImagesSlider(productCard, productImagesArray) {
  if (Object.values(productImagesArray).length <= 1) return;

  const productImagesSlider = productCard.querySelector(selectors.productImage);
  const originalImgTag = productImagesSlider.querySelector('img');
  const originalImgWidth = originalImgTag.clientWidth;

  Object.values(productImagesArray).forEach((image, index) => {
    
    if (index === 0) {
      originalImgTag.style.minWidth ='286px';
      return;
    } 
    

    const img = originalImgTag.cloneNode(true);
    img.src = image;

    const srcset = img.srcset;
    const updatedSrcset = srcset.replace(
      /https:\/\/cdn\.shopify\.com\/s\/files\/[^\s]+/g,
      image
    );

    img.srcset = updatedSrcset;
    img.style.minWidth = originalImgWidth + 'px';
    productImagesSlider.appendChild(img);
  });

  const prevArrowIcon = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.75 19.5L7.25 12L14.75 4.5" stroke="#0F0F0F" stroke-width="1.5" stroke-linecap="square"></path>
    </svg>
  `;

  const nextArrowIcon = `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.25 4.5L16.75 12L9.25 19.5" stroke="#0F0F0F" stroke-width="1.5" stroke-linecap="square"></path>
    </svg>
  `;

  const prevArrow = document.createElement('div');
  prevArrow.classList.add('boost-sd__product-image-arrow', 'boost-sd__product-image-arrow--prev');

  const nextArrow = document.createElement('div');
  nextArrow.classList.add('boost-sd__product-image-arrow', 'boost-sd__product-image-arrow--next');

  prevArrow.innerHTML = prevArrowIcon;
  nextArrow.innerHTML = nextArrowIcon;


  productImagesSlider.parentNode.appendChild(prevArrow);
  productImagesSlider.parentNode.appendChild(nextArrow);

  prevArrow.addEventListener('click', (e) => {
    e.preventDefault();
    prevArrow.disabled = true;
    const step = originalImgTag.offsetWidth;
    productImagesSlider.scrollBy({ left: -step, behavior: 'smooth' })
    setTimeout(() => { 
      prevArrow.disabled = false;
    }, 100);
  })

  nextArrow.addEventListener('click', (e) => {
    e.preventDefault();
    prevArrow.disabled = true;
    const step = originalImgTag.offsetWidth;
    productImagesSlider.scrollBy({ left: step, behavior: 'smooth' });
    setTimeout(() => { 
      prevArrow.disabled = false;
    }, 100);
  })

  let isScrolling;
  let isResizing;
  
  window.addEventListener('resize', () => {
    clearTimeout(isResizing);
    isResizing = setTimeout(() => {
        const imageWidth = productImagesSlider.querySelector('img').clientWidth;
        const scrollPosition = productImagesSlider.scrollLeft;
        const index = Math.round(scrollPosition / imageWidth);
        productImagesSlider.scrollTo({ left: index * imageWidth, behavior: 'smooth' });

        productImagesSlider.querySelectorAll('img').forEach((img) => {
          img.style.minWidth = img.parentNode.offsetWidth + 'px';
        });
    }, 150);
  });

  productImagesSlider.addEventListener('scroll', () => {
    clearTimeout(isScrolling);
    isScrolling = setTimeout(() => {
        const imageWidth = productImagesSlider.querySelector('img').clientWidth;
        const scrollPosition = productImagesSlider.scrollLeft;
        const index = Math.round(scrollPosition / imageWidth);
        productImagesSlider.scrollTo({ left: index * imageWidth, behavior: 'smooth' });
    }, 150);
  });

}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductItemWidget", {
      name: "ProductItemWidget Modify",
      enabled: true,
      apply: () => ({
        afterRender(element) {
          const rootElement = element.getRootElm();
          console.log(rootElement)
          const productHandle = element.getParams().props?.product?.handle;
          // Build Product Image Slider
          if (!rootElement.dataset.sliderInit && !_isMobileDevice() && _isCollectionPage()) {
            rootElement.dataset.sliderInit = true;
            const productImages = element.getParams().props?.product?.images;
            setTimeout(() => {
               buildProductImagesSlider(rootElement, productImages);
            }, 500);
          }
        },
      }),
    });
  },
]);
/* end  */


const customize = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  if (productItem) {
                     /* use pure js here */
                     /* Example - Add percent sale info */
                        const vendor = `<div class="boost-sd-vendor">${productData.vendor}</div>`;
                        if (!productItem.querySelector('.boost-sd-vendor')) {
                           productItem.querySelector('.boost-sd__product-link').insertAdjacentHTML('afterend', vendor );
                        }
                      /* End example */
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);
